// Componente per la gestione diu n loader
import React from 'react';
import {ClassName} from 'mgToolsKit';
import css from './loader.module.less';
import PropTypes from 'prop-types';

// Init Configuration
var componentName = 'LoaderComponent';

export default class Loader extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    renderText(){
        return (
            <div className={css['loader-text']}>
                {this.props.text}
            </div>
        )
    }

    renderMaskLoader(){        
        var  {theme} = this.context;
        const {size} = this.props;

        var styles = {};
        if(theme.primaryColor != ""){
            styles["border"] = size + "px solid " + theme.primaryColor;
        }
        styles["borderRightColor"] = "transparent";
        var _themeVersion = "wrap-loader-maskLoader-" + this.context.theme.type;       

        return (
            <div className={css[_themeVersion]}>
                <div style={styles} className={css['loader-maskLoader']}></div>
            </div>
        )
    }


    renderCircular(){
        var  {theme} = this.context;
        const {size} = this.props;
        var styles = {}
        if(theme.primaryColor != ""){
            styles["border"] = size+"px solid " + theme.primaryColor;
        }
        styles["borderRightColor"] = "transparent";
        return (
            <div style={styles} className={css['loader-circular']}>
            </div>
        )
    }

    renderProgress(){
        var  {theme} = this.context;
        const {size} = this.props;
        var styles = {};
        if(theme.primaryColor != ""){
            styles["backgroundColor"] = theme.primaryColor;
        }
        return (
            <div style={styles} className={css['loader-progress']}>

            </div>
        )
    }

    render() {
        var  {theme} = this.context;

        var  arrayClassName = [css["mg-loader"]];
        const  {className} = this.props;
        if(className != undefined){
            arrayClassName.push(className);
        }
        var _className = ClassName(arrayClassName);

        var progress;
        switch(this.props.type){
             case "maskLoader":
                progress = this.renderMaskLoader();
                break;

            case "circular":
                progress = this.renderCircular();
                break;

            case "progressBar":
                progress = this.renderProgress();
                break;

            case "text":
            default:
                progress = this.renderText();
        }
        
        return (
            <div className={_className}>
                {progress}
            </div>
        )
    }
}

Loader.displayName = componentName;

// PropTypes validation
Loader.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['text', 'circular', 'progressBar', 'maskLoader']),
    text: PropTypes.string,
    size: PropTypes.number
};

// default props
Loader.defaultProps = {
    size: 2,
    type: "text",
    text: "Caricamento in corso..."
};

Loader.contextTypes = {
    /*
    * Context per la gestione del tema
    * */
    theme: PropTypes.object
}